// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import styled from 'styled-components';

const StyledArea = styled(FormGroup)`
  textarea {
    min-height: 200px;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const ActivityAvailableCalendar = ({ value, onMetaFieldsChange }) => {
  const onChange = event => {
    onMetaFieldsChange([{ name: 'hours', value: event.target.value }]);
  };

  return (
    <StyledArea controlId='calendar-area'>
      <FormControl
        componentClass='textarea'
        value={value}
        onChange={onChange}
      />
    </StyledArea>
  );
};

export default ActivityAvailableCalendar;
